// extracted by mini-css-extract-plugin
module.exports = {"rootSmall":"List_rootSmall__RQnvX","rootMedium":"List_rootMedium__2mDtu","rootLarge":"List_rootLarge__3p9gW","header":"List_header__1eDSl"};